import { EMPTY_VALUE } from './vars';

// eslint-disable-next-line @typescript-eslint/no-explicit-any,@typescript-eslint/explicit-module-boundary-types
export const valueOrDash = (value: any) => {
  return value ?? EMPTY_VALUE;
};
